export interface TopTickets {
    paginator: Paginator;
    period: string;
    from: Date;
    lastTicketSettledAt: Date;
}

export interface Paginator {
    year: Month;
    month: Month;
    week: Month;
    data: TopTicketsData;
}

export interface TopTicketsData {
    "highest-wins": HighestBonus;
    "highest-odds": HighestBonus;
    "highest-bonus": HighestBonus;
    "most-lines": HighestBonus;
    "live-bets": HighestBonus;
    "top-losers": HighestBonus;
}

export interface HighestBonus {
    id: number;
    category: string;
    player: string;
    bet: number;
    odds: number;
    prize: number;
    potential_prize: number;
    lines: number;
    akobonus: number;
    akobonus_rate: number;
    settled_at_iso: Date;
}

export interface Month {
    previous: string;
    current: string;
    next: string | null;
    label: string;
}

export enum TopTicketPeriod {
    WEEK = "week",
    MONTH = "month",
    YEAR = "year",
}
